// Node-level event callbacks for outbound call (legacy PHLO). SER-4772.
// Lives outside the sidebar component file so Fast Refresh can preserve
// component state (only-export-components).
export const initiateCallEventTypes = [
  { value: 'answer', label: 'Answer' },
  { value: 'hangup', label: 'Hangup' },
  { value: 'machine_detection', label: 'Machine Detection' },
  { value: 'record', label: 'Record' },
  { value: 'ringing', label: 'Ringing' },
]
